'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { useNotificationSocket } from '@features/websocket/hooks/useNotificationSocket'
import { socketConfigs } from '@features/websocket/socketConfigs'
import { cleanupAll, handleBrowserRouteChange, registerConfigs } from '@features/websocket/socketService'

export default function SocketRouteBridgePages() {
  useNotificationSocket()
  const pathname = usePathname()

  useEffect(() => {
    registerConfigs(socketConfigs)

    return cleanupAll
  }, [])

  useEffect(() => {
    handleBrowserRouteChange(pathname)
  }, [pathname])

  return null
}
